module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_4_3.bfd45cb8.png";